import ColorizeIcon from '@mui/icons-material/Colorize';
import { Box, IconButton, Popover } from '@mui/material';
import React, { useContext, useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import { AppearanceContext } from '../../../contexts';
import ThemeButton from './ThemeButton';

// interface IThemeMenuOptionsProps {
//   open: boolean;
// }

const ThemeMenuOptions = () => {
  // const { open } = props;
  const [color, setColor] = useState('#aabbcc');
  const [modalOpen, setModalOpen] = React.useState(false);

  const appearanceContext = useContext(AppearanceContext);
  const [anchorEl, setAnchorEl] =
    React.useState<HTMLButtonElement | HTMLDialogElement | null>(null);

  const _handleClose = () => {
    setAnchorEl(null);
    setModalOpen(false);
  };
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      <Box
        sx={{
          m: 1,
          display: 'grid',
          gridGap: '6px',
          justifyItems: 'center',
          gridTemplateColumns: '1fr 1fr 1fr 1fr',
        }}
      >
        {ThemeButton('blue', '#5272AC')}
        {ThemeButton('red', '#f1645b')}
        {ThemeButton('green', '#2c6e49')}
        {ThemeButton('darkBlue', '#255f85')}
        {ThemeButton('pink', '#ffa9a3')}
        {ThemeButton('violet', '#8780ff')}
        {ThemeButton('lightBlue', '#4da9ff')}
        <IconButton
          sx={{ p: 0 }}
          onClick={(e) => {
            setModalOpen(true);
            setAnchorEl(e.currentTarget);
          }}
        >
          <ColorizeIcon />
        </IconButton>
        <Popover anchorEl={anchorEl} onClose={_handleClose} open={modalOpen}>
          <HexColorPicker
            color={color}
            onChange={(themeColor) => {
              setColor(themeColor);
              appearanceContext.setTheme(themeColor);
            }}
          />
        </Popover>
      </Box>
    </>
  );
};
export default ThemeMenuOptions;
